import React, { useContext, useEffect } from 'react';
import { CircularProgress, makeStyles } from '@material-ui/core';
import { useParams, useHistory } from 'react-router-dom';

import { NotificationCtx } from 'components/notification/notification-hook';
import { AuthCtx } from 'components/auth/auth-ctx';
import { getResearchSheet } from 'modules/portfolio-research-sheet/research-sheet-api';
import { NotificationVariant } from 'components/notification/notification-types';

export const useStyles = makeStyles({
  loader: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: 200,
  },
});

interface RedirectFromAdminProps {
  sheetId: string;
}

export const RedirectFromAdmin: React.FC = () => {
  const classes = useStyles();
  const { sheetId } = useParams<RedirectFromAdminProps>();
  const history = useHistory();
  const { showNotification } = useContext(NotificationCtx);
  const { userLoaded, setUserSheet } = useContext(AuthCtx);

  useEffect(() => {
    if (userLoaded) {
      const loadSheet = async () => {
        localStorage.setItem('userSheetId', sheetId);
        const newUserSheet = await getResearchSheet(sheetId);

        if (!!newUserSheet) {
          setUserSheet?.(newUserSheet);
          history.replace('/portfolio/zadat-badatelsky-dotaz');
        } else {
          showNotification(
            'Nastala chyba při načtení notifikace.',
            NotificationVariant.ERROR
          );
          history.replace('/');
        }
      };

      loadSheet();
    }
  }, [history, setUserSheet, sheetId, showNotification, userLoaded]);

  return (
    <div className={classes.loader}>
      <CircularProgress />
    </div>
  );
};
